import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { CreateOrderRoamingDto, CreateOrderRoamingResp } from './create-order-roaming.type';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { CreateOrder } from '@data/domain/checkout.entity';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class CreateOrderRoamingUsecase implements UseCase<CreateOrderRoamingDto, CreateOrderRoamingResp> {
    checkoutRepository = inject(CheckoutRepository);

    execute(params: CreateOrderRoamingDto): Observable<CreateOrder> {
        return this.checkoutRepository.CreateOrderRoaming(params);
    }
}